import { render, staticRenderFns } from "./PappersChiefs.vue?vue&type=template&id=3fdbf3a4&scoped=true"
import script from "./PappersChiefs.vue?vue&type=script&lang=js"
export * from "./PappersChiefs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdbf3a4",
  null
  
)

export default component.exports